<template>
  <span class="roundel-row">
    <ResourceLabel v-for="v in listOfResources" :id="v" :key="v" :resFunction="resFunction"></ResourceLabel>
  </span>
</template>

<script>
import ResettableTimeout from 'CORE/utils/resettable-timeout'
import DataTypeProsMixin from 'CORE/mixins/dataType'
import ResourceLabel from 'CORE/components/resource/label'
import _ from 'lodash'

export default {
    name: 'LinkResourceDetail',
    components: {
        ResourceLabel,
    },
    props: {
        resFunction: {
            type: String,
            required: false,
        },
    },
    mixins: [
        DataTypeProsMixin,
    ],
    computed: {
        listOfResources() {
            const value = this.value.value.value
            if(_.isArray(value)) {
                return value
            } else {
                if(_.size(value) > 0) {
                    return [value]
                }
            }
            return []
        }
    }

}
</script>

<style>
.roundel-row {
    display: flex;
    flex-direction: row;
}
</style>
